import router from './index'
import store from '../store'
import { indexPage, loginPage } from "../config/config"
import { whiteList } from "../api/config"
import Vue from "vue"
import ViewUI from 'view-design'
import { configList } from "../views/official/mock"
import { httpAgent } from '@/api/ajax'

router.beforeEach(async (to, from, next) => {
  // 开始加载进度条
  ViewUI.LoadingBar.start()

  // 设置页面title
  // request({
  //   url: "/agent/config/preGet",
  //   method: "get",
  // }).then(res => {
  //   if (res.id) {
  //     let siteTitle = res && res.companyName
  //     document.title = siteTitle ? (to.meta.title + ' -' + siteTitle) : to.meta.title
  //   }
  // }).catch(error => {})
  httpAgent({
    url: `${location.hostname == 'localhost' ? 'http://gateway.eline56.test' : ''}/agent/config/preGet`,
    method: "get",
  }).then((res) => {
    if (res.id) {
      let siteTitle = res && res.companyName
      document.title = siteTitle ? (to.meta.title + ' -' + siteTitle) : to.meta.title
    }
  })
  

  // 确定用户是否已登录
  const isLogin = store.getters.isLogin

  if (isLogin) { // 判断是否有token
    if (to.path === '/login') {
      // 如果已登录，重定向到主页
      next()
      // 停止加载进度条
      ViewUI.LoadingBar.finish()
    } else {
      let arr = ["/vgm", '/cps','/cps/draft','/cps/waiting','/cps/send','/cps/update','/cps/delete','/cps/counterDelete','/cps/detail']
      if (arr.includes(to.path)) {
        let routerListItem = ruleValidate(configList, to.path)
        if(!routerListItem.productCode){
          routerListItem.productCode = 'shcps';//cps下其他路由统一为shcps
        }
        if (routerListItem.productCode) {
          httpAgent({
            url: `/agent/product/status`,
            method: "get",
            data: { productCode: routerListItem.productCode }
          }).then((response) => {
            if (response == 1) {
              next()
              // if (response.data == "已开通") {
              //   // next()
              // } else {
              //   //不是代理系統需要走開通校驗
              //   //if (!agentType) {
              //     //Vue.prototype.$message({ message: '该产品未开通', type: 'warning' })
              //     //next({ name: 'empty' })
              //   //}
              //   // next({ name: 'product' })
              // }
            } else {
              // Vue.prototype.$message({ message: response.msg, type: 'warning' })
              // next({ name: 'certification' })
              Vue.prototype.$message({ message: '该产品未开通', type: 'warning' })
              next({ name: 'empty' })
            }
          })
        }
      }

      // 确定用户是否已通过getInfo获得其权限角色
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        // debugger
        let item = {
          fullPath: to.fullPath,
          meta: to.meta,
          name: to.name,
          path: to.path
        }
        // 增加tab多页签数据
        store.dispatch('tagsView/pushRouter', item)


        next()

        // if(from.meta.isEdit){
        //   Vue.prototype.$confirm('您确定要退出此页面?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        // }).then(() => {
        //     next()

        // })

        // }else{
        //   next()

        // }
      } else {
        console.log(3)

        try {
          // 获取用户信息 这里可以进行一些操作
          const { roles } = await store.dispatch('user/getInfo')

          // 根据角色生成可访问的路由
          const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
          // 增加异步路由
          router.addRoutes(accessRoutes)

          // hack方法，以确保addRoutes是完整的
          // 设置replace：true，导航不会留下历史记录
          next({ ...to, replace: true })
        } catch (error) {
          // 删除token并进入登录页面以重新登录
          // await store.dispatch('user/resetToken')
          // ViewUI.Message.error(error || 'Has Error')
          this.$message({
            message: error || 'Has Error',
            type: 'error'
          })
          next({ name: loginPage })
          // 停止加载进度条
          ViewUI.LoadingBar.finish()
        }
      }
    }
  } else {
    console.log(4)

    /* 没有 token*/
    if (whiteList.includes(to.path)) {
      // 免权限直接进入
      next()
    } else {
      // 其他无权访问的页面将重定向到登录页面
      next({ name: loginPage })
      // 停止加载进度条
      ViewUI.LoadingBar.finish()
    }
    // if (window.location.hostname.indexOf('app.') < 0 && window.location.hostname.indexOf('www.') < 0) {
    // }
    return
  }
})

router.afterEach((to, from, next) => {
  // 停止加载进度条
  ViewUI.LoadingBar.finish()
  // 路由切换 滚到到顶部
  window.scrollTo(0, 0)
  if (to.name !== loginPage) {
    // 如果不是登录页 内容区域滚动到顶部
    Vue.nextTick(() => {
      if (document.getElementById('main_content')) {
        document.getElementById('main_content').scrollTo(0, 0)
      }
    })
  }
})


//  返回当前路由对象
function ruleValidate (list, path) {
  let flag = true
  var obg = {}
  function judgeChildren (list) {
    list.forEach(e => {
      if (!flag) {
        return
      }
      if (e.jump_url == path) {
        obg = e
        flag = false
        return
      } else if (e.child_node_list && e.child_node_list.length) {
        judgeChildren(e.child_node_list)
      }
    })
  }
  judgeChildren(list)
  return obg
}
